import { Row, Col, Card, Typography, Form, Button } from "antd";
import { FormInputItem, FormPasswordItem } from "../components/formInput";
import { use, useEffect, useState } from "react";
import { KeyOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setState } from "../redux/user";
import toast from "react-hot-toast";
import { AgentLogin } from "../lib/api";
import axios from "axios";
const { Text } = Typography;


export default function Login() {

  const { select_theme } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [csrfToken, setCsrfToken] = useState("");

  async function getCsrfToken() {
    await axios
      .get(`${process.env.REACT_APP_SERVER_API}/services/token`, {
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Credentials": true,
        },
        withCredentials: true
      })
      .then((res) => {
        setCsrfToken(res.data.csrfToken || "12345678")
      })
      .catch((error) => {
        console.log("token fetching error", error);
      });
  }
  useEffect(() => {
    getCsrfToken();
  }, []);


  async function submitHandler(values) {
    setLoading(true);

    await AgentLogin(values, csrfToken)
      .then((res) => {
        setLoading(false);
        const { access_token, ...user } = res.data;
        console.log("user...", user)
        dispatch(
          setState({
            csrf_token : csrfToken,
            access_token,
            id: user.id,
            code: user.code,
            name : user.name,
            address : user.address,
            email : user.email,
            phone : user.phone,
            permissions: user.permissions,
            points : user.agent.points,
            total_deposit_points : user.agent.total_deposit_points,
            total_withdraw_points : user.agent.total_withdraw_points,
            select_theme: user.theme?.toLowerCase(),
            ui_size: user.ui_size?.toLowerCase(),
          })
        );
        navigate("/");
        toast.success("Login Successfully");
      })
      .catch((error) => {
        setLoading(false);
        error.response?.data?.statusCode === 400
          ? toast.error(error.response?.data?.error)
          : error.response?.data?.statusCode === 401
            ? toast.error(error.response?.data?.error)
            : toast.error("Connection Error");
      });
  }
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col>
        <Card
        style = {{backgroundColor: select_theme === "white" ? "#ffffff" : "#000000",}}
        >
          <Row justify="center" style={{ marginBottom: "24px" }}>
            <Col>
              <Text strong style={{ fontSize: "32px" }}>
                Agent Login
              </Text>
            </Col>
          </Row>
          <Form form={form} onFinish={submitHandler}>
            <FormInputItem
              name="code"
              placeholder="Code"
              icon={<UserOutlined />}
              rules={[
                { required: true},
              ]}
            />

            <FormPasswordItem
              name="password"
              placeholder="Password"
              icon={<KeyOutlined />}
              rules={[{ required: true}]}
            />
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
